import { render, staticRenderFns } from "./record_detail.vue?vue&type=template&id=51f55804&scoped=true&"
import script from "./record_detail.vue?vue&type=script&lang=js&"
export * from "./record_detail.vue?vue&type=script&lang=js&"
import style0 from "./record_detail.vue?vue&type=style&index=0&id=51f55804&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f55804",
  null
  
)

export default component.exports